import Image from 'next/image';
import { cn, getAssetSrc } from '@restworld/utils-common';
import { Heading, Text, Button, Logo } from '@restworld/ui-ds-base';
import { useTranslation } from 'next-i18next';
import { JobApplicationEntryPoint } from '../job-application-entry-point';

export const WhyTrustUs = () => {
  const { t } = useTranslation('job-position-page');
  return (
    <>
      <StyledWrapper>
        <div className="flex flex-row gap-2 items-center mb-2">
          <Logo variant="mark" title="restworld" className="h-8 w-8 text-white" />
          <Heading size={4} color="white">
            {t('why_trust_us.header')}
          </Heading>
        </div>
        <Text size={2} color="white">
          {t('why_trust_us.description')}
        </Text>
        <div className="flex flex-col gap-1 items-start my-2">
          <Text size={2} color="white" weight="semibold">
            {t('why_trust_us.our_offers.header')}
          </Text>
          <ul className="list-disc text-white list-inside pl-2.5">
            <li>
              <Text size={2} color="white" className="inline-block">
                {t('why_trust_us.our_offers.bullet_1')}
              </Text>
            </li>
            <li>
              <Text size={2} color="white" className="inline-block">
                {t('why_trust_us.our_offers.bullet_2')}
              </Text>
            </li>
            <li>
              <Text size={2} color="white" className="inline-block">
                {t('why_trust_us.our_offers.bullet_3')}
              </Text>
            </li>
          </ul>
        </div>
        <div className="flex flex-col gap-1 items-start mb-2">
          <div className="flex flex-row gap-2 pl-0 items-center justify-start">
            <Image
              width={64}
              height={64}
              src={getAssetSrc('/utils-assets/restworld-team.svg')}
              alt="restworld"
              priority
            />
            <Heading size={5} color="white">
              {t('why_trust_us.team_motivation')}
            </Heading>
          </div>

          <Text size={2} color="white">
            {t('why_trust_us.recruiter_motivation')}
          </Text>
        </div>
        <Heading size={5} color="white">
          {t('why_trust_us.contact_text')}
        </Heading>
        <div className="lg:grid  lg:grid-cols-2  flex flex-col items-center gap-2  w-full mt-2">
          <JobApplicationEntryPoint />
          <a
            href="https://www.restworld.it/assistenza/13941603-come-funziona-il-servizio-di-restworld"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary-800 cursor-pointer w-full"
          >
            {/* Master used variant="white-ghost" (transparent, white, underlined, NO border).
                tertiary-reversed adds an inset-shadow border, so strip it with shadow-none. */}
            <Button variant="tertiary-reversed" className="underline shadow-none" fullwidth={true}>
              {t('why_trust_us.contact_link')}
            </Button>
          </a>
        </div>
      </StyledWrapper>
      <hr className="text-gray-300 lg:block hidden" />
    </>
  );
};

const StyledWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div
    className={cn('bg-primary-700 p-4 rounded-3.75 w-full flex flex-col items-start gap-0 mt-0', className)}
    {...props}
  />
);
